import axios from '../app/axios';
import { endpoints } from 'src/utils/constants';
import RequestHeaders from '../enums/RequestHeaders';

interface ProformaLinkResponse {
    link: string;
}
export async function getProformaInvoiceTempLink(
    uuid: string,
    workspaceId: string
): Promise<string> {
    // endpoints.proforma_invoices.link is expected to be something like
    // '/proforma_invoices/{uuid}/link'
    const url = endpoints.proforma_invoice.link.replace('{uuid}', uuid);

    const raw = await axios.get<ProformaLinkResponse>(url, {
        headers: {
            [RequestHeaders.WORKSPACE_ID]: workspaceId,
        },
        responseType: 'text',
    }).then(r => r.data)

    const parsed = JSON.parse(raw) as { link: string } | string
    return typeof parsed === 'object' ? parsed.link : parsed
}
